module.exports = __webpack_public_path__ + "static/media/Excell.112c19bd.svg";